export var Popups;

(function (Popups) {
  Popups["Success"] = "Success";
  Popups["Info"] = "Info";
  Popups["Error"] = "Error";
  Popups["Default"] = "Default";
  Popups["NotReceiveCode"] = "NotReceiveCode";
})(Popups || (Popups = {}));